import React, { useEffect } from "react";
import styled from 'styled-components';
import EsApplyForm from "../../components/es/EsApplyForm";
import EsApplyPckg from "../../components/es/EsApplyPckg";
import Header from "../../components/common/header/Header";
import { useDispatch, useSelector } from "react-redux";
import { setCurMenuAction, setHeaderTransferAction } from "../../modules/common/headerModule";
import LoadingOverlay from 'react-loading-overlay';
import { setEsApplyDelAllAction } from "../../modules/es/esApplyModule";

const EsApplyBlock = styled.div``;

const EsApplyContentsBlock = styled.div`
    width: 100%;
    max-width: 1176px;
    margin: 0 auto;
    padding-top: 80px
`;

const EsApplyTitleBlock = styled.h2`
    margin: 90px 0;
    font-size: 32px;
    font-weight: 300;
    text-align: center;
`;

const EsApplyTitleBoldBlock = styled.b`
    font-weight: 500;
`;

const EsApply = () => {

    const dispatch = useDispatch();

    const { loading } = useSelector(
        ({ loadingReducer }) => ({
            loading: loadingReducer['esapply/REQ_TYPE_POST_ESAPPLY'],

        })
    );

    // 최소 실행시 Header 관련 처리 추가  
    useEffect(() => {
        dispatch(setCurMenuAction('esapply'));
        dispatch(setHeaderTransferAction(false));
        dispatch(setEsApplyDelAllAction());
    }, []);

    return (
        <EsApplyBlock>
            <LoadingOverlay
                active={loading}
                spinner
                text=''
            >
                <Header />
                <EsApplyContentsBlock>
                    <EsApplyTitleBlock>
                        <EsApplyTitleBoldBlock>나만의 가구 견적서</EsApplyTitleBoldBlock>
                    를 작성해주세요!
                </EsApplyTitleBlock>
                    <EsApplyForm />
                    <EsApplyPckg />
                </EsApplyContentsBlock>
            </LoadingOverlay>
        </EsApplyBlock>
    );
};

export default EsApply;
